<template>
	<div>
	<!-- Speed Dial FAB -->
	<SpeedDialFab />
	<div id="account-actions" class="-logged" style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000;">
        <div class="x-button-actions" id="account-actions-mobile">
          <div class="-outer-wrapper">
            <div class="-left-wrapper">
              <router-link to="/" class="-item-wrapper -promotion">
                <picture>
                  <source
                    type="image/png"
                    srcset="../assets/images/home.png"
                  />
                  <img
                    src="../assets/images/home.png"
                    class="-ic-img"
                    alt="Time2lucky ไอคอนหน้าแรก"
                    width="34"
                    height="34"
                  />
                </picture>
                <span class="-text">{{ $t('footer.home') }}</span>
              </router-link>
              <a
                href="javascript:void(0);"
                class="-item-wrapper -deposit js-account-approve-aware"
                @click="handleDepositClick()"
              >
                <picture>
                  <source
                    type="image/png"
                    srcset="../assets/images/icdeposit.png"
                  />
                  <img
                    src="../assets/images/icdeposit.png"
                    class="-ic-img"
                    alt="time2lucky รูปไอคอนไลน์"
                    width="34"
                    height="34"
                  />
                </picture>
                <span class="-text">{{ $t('footer.deposit') }}</span>
              </a>
            </div>

            <router-link to="/play" class="-center-wrapper" aria-label="ทางเข้าเล่น">
              <div
                class="-selected"
                :style="{ backgroundImage: `url(${require('../assets/images/menu/play-1.png')})` }"
              >
                <img
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  data-src="../assets/images/shiba888-curve-top.png"
                  class="-top-curve lazyload"
                  alt="time2lucky คาสิโนออนไลน์ระดับโลก รวม คาสิโน บาคาร่าสด สล็อต และกีฬา"
                />
                <img
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  data-src="../assets/images/shiba888-curve-bottom.png"
                  class="-bottom-curve lazyload"
                  alt="time2lucky คาสิโนออนไลน์ระดับโลก รวม คาสิโน บาคาร่าสด สล็อต และกีฬา"
                />
              </div>
            </router-link>
            <div
              class="-fake-center-bg-wrapper"
              style="position: absolute;z-index: 1;width: 100%;height: 50px;overflow: hidden;left: 0;bottom: 0;"
            >
              <svg viewbox="-10 -1 30 12">
                <defs>
                  <linearGradient
                    id="rectangleGradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                  >
                    <stop offset="20%" stop-color="#300b49" />
                    <stop offset="100%" stop-color="#0c0313" />
                  </linearGradient>
                </defs>
                <path
                  d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"
                />
              </svg>
            </div>

            <div class="-right-wrapper">
				      <a
                href="javascript:void(0);"
                class="-item-wrapper -withdraw js-account-approve-aware"
                @click="handleWithdrawClick()"
              >
                <picture>
                  <source
                    type="image/png"
                    srcset="../assets/images/icwithdraw.png"
                  />
                  <img
                    src="../assets/images/icwithdraw.png"
                    class="-ic-img"
                    alt="time2lucky รูปไอคอนไลน์"
                    width="34"
                    height="34"
                  />
                </picture>
                <span class="-text">{{ $t('footer.withdraw') }}</span>
              </a>
              <a
                :href="adminContactLineLink"
                target="_blank"
                class="-item-wrapper -line"
                rel="noopener noreferrer"
                @click="toggleDropdown"
              >
                <picture>
                  <source
                    type="image/png"
                    srcset="../assets/images/shiba888-ic-mobile-left-1.png"
                  />
                  <img
                    src="../assets/images/shiba888-ic-mobile-left-1.png"
                    class="-ic-img"
                    alt="time2lucky รูปไอคอนไลน์"
                    width="34"
                    height="34"
                  />
                </picture>
                <span class="-text">{{ $t('footer.contact_us') }}</span>
              </a>
              <!-- <div v-if="isDropdownVisible" style="display:flex; position: absolute; bottom: 100%; right: 10px; flex-direction: column; gap: 10px; z-index: 1;">
                <div class="sub-button" style="width: 50px; height: 50px; background-color: #4ba2ff; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); cursor: pointer;">
                  <a href="https://www.facebook.com/profile.php?id=100080810944069" target="_blank"><img src="../assets/images/icons/facebook.png" width="50"></a>
                </div>
                <div class="sub-button" style="width: 50px; height: 50px; background-color: #4ba2ff; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); cursor: pointer;">
                  <a href="https://t.me/time2luckysupport" target="_blank"><img src="../assets/images/icons/telegram.png" width="50"></a>
                </div>
                <div class="sub-button" style="width: 50px; height: 50px; background-color: #4ba2ff; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); cursor: pointer;">
                  <a :href="adminContactLineLink" target="_blank"><img src="../assets/images/icons/line.png" width="50"></a>
                </div>
            </div> -->
            </div>
            <div class="-fully-overlay js-footer-lobby-overlay"></div>
          </div>
        </div>
      </div>
    <div class="-main-footer-container js-replace-main-footer-container">
	<footer class="x-footer ">
		<div class="container-fluid -footer-wrapper">
		<div class="-footer-bottom-wrapper">
			<div>
			<p class="mb-0" style="padding-top:20px;">
				Copyright © {{ currentYear }} time2lucky All Rights Reserved.
			</p>
			</div>
		</div>
		</div>
	</footer>
	</div>
	</div>
</template>
<script>
import firebase from 'firebase/app'
import router from './../router'
import SpeedDialFab from '@/components/SpeedDialFab.vue'
import { getWithdrawConditionOnce } from '@/utils/withdrawConditionCache'

export default {
  name: 'Footer',
  components: {
    SpeedDialFab
  },
  data() {
    return {
      isDropdownVisible: false,
      disabled: false,
      condition: {
        detail: '',
        maximum: 0,
        minimum: 0,
        maximumperday: 0,
        disableDeposit: false,
        disableWithdraw: false
      }
    };
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    user () {
      return this.$store.state.user.user
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    adminContactLineLink () {
      return this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine']
    }
  },
  watch: {
    'user.key': {
      immediate: true,
      handler (newKey) {
        if (newKey && !this.condition.maximum) {
          this.callGetWithdrawCondition()
        }
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    async moveCreditToWallet(){
      if(this.disabled){
        return { status: false, promoHandled: false }
      }

      this.disabled = true
      this.$store.commit('user/SET_LOADING', true)
      try {
        const user = this.getUserId()
        const moveResult = await this.$store.dispatch('user/moveCreditToWallet')
        if(!moveResult || moveResult.status !== true){
          throw new Error((moveResult && (moveResult.error || moveResult.message)) || 'ไม่สามารถโยกเครดิตกลับเข้ากระเป๋าหลักได้')
        }

        const promoResult = await this.$store.dispatch('user/preparePromoWithdrawal', user)
        if(!promoResult || promoResult.status !== true || promoResult.withdrawBlocked){
          this.$swal({
            icon: 'warning',
            title: 'ยังไม่สามารถถอนได้',
            text: (promoResult && promoResult.blockingMessage) || 'กรุณาลองใหม่อีกครั้ง'
          })
          return { status: false, promoHandled: Boolean(promoResult && promoResult.activePromotion) }
        }

        if(promoResult.activePromotion){
          this.$store.commit("user/SET_ALERT_WITHDRAWALL", true)
          return { status: true, promoHandled: true }
        }
        return { status: true, promoHandled: false }
      } catch (err) {
        console.error(err)
        this.$swal({
          icon: 'error',
          title: 'ไม่สามารถเตรียมรายการถอนได้',
          text: err.message || 'กรุณาลองใหม่อีกครั้ง'
        })
        return { status: false, promoHandled: false }
      } finally {
        this.$store.commit('user/SET_LOADING', false)
        setTimeout(() => {
          this.disabled = false
        }, 2000)
      }
    },
    async checkPromotions () {
      this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/checkPromotions').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
    changeLanguage (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('language', locale)
    },
    async callGetWithdrawCondition () {
      try {
        const condition = await getWithdrawConditionOnce(this.user.key)
        if (condition) {
          this.condition = condition
        }
      } catch (error) {
        console.error('getWithdrawCondition error:', error)
      }
    },
    handleDepositClick () {
      this.$root.$emit('request-deposit')
    },
    async handleWithdrawClick () {
      if (this.condition.disableWithdraw) {
        this.$swal({
          icon: 'warning',
          title: 'ระบบถอนเงินปิดปรับปรุง',
          text: 'กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
        })
        return
      }
      const result = await this.moveCreditToWallet()
      if(result && result.status && !result.promoHandled){
        window.$('#withdrawModal').modal('show')
      }
    }
  }
}
</script>

<style scoped>
/* Reserve space for the fixed navigation once, including its raised play button. */
@media (max-width: 991.98px) {
  .-main-footer-container {
    margin-bottom: 0;
    padding-bottom: calc(var(--mobile-footer-clearance, 124px) + env(safe-area-inset-bottom, 0px));
  }

  .x-footer .-footer-wrapper {
    padding-bottom: 0;
  }
}

@media (max-width: 768px) {
  #account-actions {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000 !important;
    background: linear-gradient(180deg, #300b49 0%, #0c0313 100%);
  }
}
</style>
